import { combineReducers, configureStore } from '@reduxjs/toolkit';
import entities from './entities';

const rootReducer = combineReducers({
  entities,
});

export default configureStore({
  reducer: rootReducer,
});
